import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { first } from 'rxjs';

export const eventsValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const name = control.get('name');
  const description = control.get('description');

  var isValid = false

  if (name != null && name.value != "" && description != null && description.value != "")  {
    isValid = true
  } else {
    isValid = false
  }

  return isValid ? null : { valid: true };
};